import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { RootContext } from "../../RootContextProvider";

import { Menu } from "antd";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import LSlogo from "../../assets/logo/linksight_visual_small.svg";
import {
  UserOutlined,
  LineChartOutlined,
  BgColorsOutlined,
  LinkOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import "./sidebar.css";

const { SubMenu } = Menu;

const Sider = ({ location, history, logout }) => {
  const { listPages, account } = useContext(RootContext);
  const [selectedKey, setSelectedKey] = useState();

  useEffect(() => {
    const defineDefaultKey = async () => {
      let selectKey = await defineSelectedkey();
      setSelectedKey(selectKey);
    };
    defineDefaultKey();
    history.listen(async () => {
      let selectKey = await defineSelectedkey();
      if (selectKey) {
        setSelectedKey(selectKey);
      }
    });
    // eslint-disable-next-line
  }, [history]);

  const defineSelectedkey = async () => {
    const menu = [
      "/links",
      "/appearance",
      "/analytics",
      "/settings",
      "/admin",
      "welcome",
      "new-page",
    ];
    for (const m of menu) {
      if (window.location.pathname.startsWith(m)) {
        return m;
      }
    }
  };

  return (
    <div>
      <div className="side-top">
        {account.HasCompletedOnboarding && listPages.length > 0 ? (
          <Link to="/links">
            <div className="logo">
              <img src={LSlogo} alt="logo linksight" />
            </div>
          </Link>
        ) : listPages.length === 0 && account.HasCompletedOnboarding ? (
          <Link to="/new-page">
            <div className="logo">
              <img src={LSlogo} alt="logo linksight" />
            </div>
          </Link>
        ) : (
          <Link to="/welcome">
            <div className="logo">
              <img src={LSlogo} alt="logo linksight" />
            </div>
          </Link>
        )}
      </div>
      {listPages && listPages.length > 0 ? (
        <>
          <Menu defaultSelectedKeys={[selectedKey]} selectedKeys={selectedKey}>
            <Menu.Item key="/links" icon={<LinkOutlined />}>
              <Link to="/links">Liens</Link>
            </Menu.Item>

            <Menu.Item key="/appearance" icon={<BgColorsOutlined />}>
              <Link to="/appearance">Apparence</Link>
            </Menu.Item>
            <Menu.Item key="/analytics" icon={<LineChartOutlined />}>
              <Link to="/analytics">Analytics</Link>
            </Menu.Item>
            <Menu.Item key="/settings" icon={<SettingOutlined />}>
              <Link to="/settings">Réglages</Link>
            </Menu.Item>
          </Menu>
        </>
      ) : listPages.length === 0 && account.HasCompletedOnboarding ? (
        <Menu defaultSelectedKeys={[selectedKey]} selectedKeys={selectedKey}>
          <Menu.Item key="/new-page" icon={<LinkOutlined />}>
            <Link to="/new-page">Nouvelle page</Link>
          </Menu.Item>
        </Menu>
      ) : (
        <Menu defaultSelectedKeys={[selectedKey]} selectedKeys={selectedKey}>
          <Menu.Item key="/welcome" icon={<LinkOutlined />}>
            <Link to="/welcome">Bienvenue</Link>
          </Menu.Item>
        </Menu>
      )}
      <div className="side-bottom">
        <Menu>
          {/* <Menu.Item key="4" icon={<NotificationOutlined />}>
            Annonce
          </Menu.Item> */}
          <SubMenu key="sub1" icon={<UserOutlined size={30} />}>
            <Menu.Item key="5">
              <Link to="/admin">Mon compte</Link>
            </Menu.Item>
            <Menu.Item
              key="7"
              onClick={() => {
                logout();
              }}
            >
              Se déconnecter
            </Menu.Item>
          </SubMenu>
        </Menu>
      </div>
    </div>
  );
};

Sider.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default withRouter(Sider);
